module.exports = __webpack_public_path__ + "static/media/206-gallery15.d859a8b9.jpg";